$(document).on('turbolinks:load', function() {
  $(".comment-data").hover(function(){
    commentId = $(this).data("commentId");
    $(".a-actions-comment-"+commentId).removeClass("d-none").addClass("d-inline-block");
    }, function(){
    commentId = $(this).data("commentId");
    $(".a-actions-comment-"+commentId).removeClass("d-inline-block").addClass("d-none");
  });

  $("#issue_filter #q").on("keyup", function(e) {
    if(e.which == 13) $(this).trigger("change");
  });

  $('form#issue-save-search-form').submit(function(e) {
    searchQuery = JSON.stringify($('#issue_filter').serializeJSON());
    $('#save-search-query-field').val(searchQuery);
  });

  $("#send-alert-btn").click(function() {
    searchQuery = JSON.stringify($('#issue_filter').serializeJSON());
    $.ajax({
      type: "POST",
      url: "/saved_searches",
      data: {saved_search: {search_query: searchQuery}},
      dataType: "script"
    });    
  });

  $('#email_alerts').change(function() {
    isChecked = $(this).is(':checked');
    if (isChecked) {
      $('.alert-freq-radios').removeClass("d-none").addClass("d-block");
    }
    else {
      $('.alert-freq-radios').removeClass("d-block").addClass("d-none");
      $('#alert-daily, #alert-weekly, #alert-hourly').prop('checked', false);
    }
  });

  $('#slack-notifications').change(function() {
    isChecked = $(this).is(':checked');
    if (isChecked) {
      $('.slack-channel-dropdown').removeClass("d-none").addClass("d-block");
      $.ajax({
        type: "GET",
        url: "/organization/slack_channels"
      });    
    }
    else {
      $('.slack-channel-dropdown').removeClass("d-block").addClass("d-none");
      $('.slack-dd').val('');
    }
  });

  $('.narrative-issues-search').select2({
    theme: "bootstrap4", 
    allowClear: true,
    placeholder: {
      id: '-1', 
      text: 'Select a narrative'
    },
    ajax: { 
      url: '/issues/search.json', 
      dataType: 'json',
    }
  });

  $(document).on("show.bs.tab", 'a[data-toggle="tab"][id^="embed-tab-"]', function(event) {
    var $tabPane = $($(event.target).attr("href"));
    if(!$tabPane.length) return;

    var $embedHost = $(".platform-embed:not(.hydrated)", $tabPane);
    if(!$embedHost.length) return;

    var embedTagHTML = $embedHost.data("embed-tag");
    $embedHost.html(embedTagHTML).addClass("hydrated");

    $embedHost.removeData("embed-tag").removeAttr("data-embed-tag");
  });

  $('#issues_csv_export').click(function(e){
    e.preventDefault();

    if (confirm('Are You Sure?')){
      // qs = $('#issue_filter').serializeJSON()
      let params = new URLSearchParams(window.location.search)
      // params = jQuery.param(qs);
      url = "/issues/export_csv?" + params;
      $(this).addClass( "disabled" );
      $(this).attr('href', url);
    }
    else {
      return false;
    }

  })

  $(document).on("change", '#custom-field-container .custom-radio', function(){
    let fields_container = $(this).parent()
    if($(this).is(':checked')) {
      fields_container.find(".custom-date-fields").show();
      fields_container.find('.from-date').prop('disabled', false);
      fields_container.find('.to-date').prop('disabled', false);
    } else {
      fields_container.find(".custom-date-fields").hide();
      fields_container.find('.from-date').prop('disabled', true)
      fields_container.find('.to-date').prop('disabled', true)
    }
  });

  $(document).on("click", "#custom-field-container", function(event){
    $('input[name="labelName"]').prop('checked', false);
    event.stopPropagation();
  })

  $('.check-dropdown').on('click', function(e) {
    e.stopPropagation();
  })

  $('input[name="published_at_from"]').on('change', function(event) {
    let url = new URL(window.location.href);
    const params = new URLSearchParams(url.search)
    var published_at_from = event.target.value;
    params.delete('published_at_to');
    params.set('published_at_from', published_at_from);
    window.location.href = url.origin + url.pathname + '?' + params.toString();
  })

});
